import { ChangeDetectorRef, Component, Inject, OnDestroy } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { MatCalendar } from '@angular/material/datepicker';
import { DateAdapter, MAT_DATE_FORMATS, MatDateFormats } from '@angular/material/core';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'common-calendar-header',
  templateUrl: './calendar-header.component.html',
  standalone: true,
  styleUrls: ['./calendar-header.component.scss'],
  imports: [DatePipe],
})
export class CalendarHeaderComponent<D> implements OnDestroy {
  private _destroyed = new Subject<void>();
  prevButtonDisabled = false;
  nextButtonDisabled = false;

  constructor(
    private _calendar: MatCalendar<D>,
    private _dateAdapter: DateAdapter<D>,
    @Inject(MAT_DATE_FORMATS) private _dateFormats: MatDateFormats,
    cdr: ChangeDetectorRef,
  ) {
    _calendar.stateChanges.pipe(takeUntil(this._destroyed)).subscribe(() => cdr.markForCheck());
    this.updateDisabledStates();
  }

  ngOnDestroy() {
    this._destroyed.next();
    this._destroyed.complete();
  }

  get periodLabel(): string {
    return this._dateAdapter.format(this._calendar.activeDate, this._dateFormats.display.monthYearLabel);
  }

  previousClicked() {
    this._calendar.activeDate = this._dateAdapter.addCalendarMonths(this._calendar.activeDate, -1);
    this.updateDisabledStates();
  }

  nextClicked() {
    this._calendar.activeDate = this._dateAdapter.addCalendarMonths(this._calendar.activeDate, 1);
    this.updateDisabledStates();
  }

  updateDisabledStates() {
    if (this._calendar.minDate) {
      this.prevButtonDisabled = this.isSameYearAndMonth(this._calendar.activeDate, this._calendar.minDate);
    }
    if (this._calendar.maxDate) {
      this.nextButtonDisabled = this.isSameYearAndMonth(this._calendar.activeDate, this._calendar.maxDate);
    }
  }

  private isSameYearAndMonth(d1: D, d2: D) {
    return (
      this._dateAdapter.getYear(d1) === this._dateAdapter.getYear(d2) &&
      this._dateAdapter.getMonth(d1) === this._dateAdapter.getMonth(d2)
    );
  }
}
